import map from 'lodash/map';
import reject from 'lodash/reject';

import { connect } from 'react-redux';

import SubpageViewer from './subpage_viewer.jsx';

import {
  getAssetForContent,
  getShouldShowFooter,
  getRenderAsMobile,
  getCurrentSubpage,
  getSectionById,
  getActiveOverlayContent,
  getUseFixedNavLinks,
  getIsCurrentSubpageFullPageSection,
  getIsInPageSearchDisplayed,
  getIsInPageSearchEnabled,
  getIsNeedsRefreshDisplayed,
  getIsScrollingToTop,
  getShouldRenderHeader,
  getShouldRenderNavigation,
  getShouldRenderFooter,
  getIsUsingLegacyHeader
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  doneScrollingToTop,
  handleSubpageDisplayed,
  setIsInPageSearchDisplayed
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

const mapStateToProps = (state) => {
  const isMobile = getRenderAsMobile(state);
  const currentSubpage = getCurrentSubpage(state);
  const sections = map(currentSubpage.orderedSectionIds, sectionId => 
    getSectionById(state, sectionId)
  );
  const visibleSections = reject(sections, (section)=> !!section.isHidden);
  const overlayContent = getActiveOverlayContent(state);
  const overlayAsset = overlayContent ? getAssetForContent(state, overlayContent) : null;
  const useFixedNavLinks = getUseFixedNavLinks(state);
  const isFullPage = getIsCurrentSubpageFullPageSection(state);
  const isInPageSearchDisplayed = getIsInPageSearchDisplayed(state);
  const shouldScrollToTop = getIsScrollingToTop(state);
  const shouldShowFooter = getShouldShowFooter(state);
  const isInPageSearchEnabled = getIsInPageSearchEnabled(state) && !isMobile;
  const isNeedsRefreshDisplayed = getIsNeedsRefreshDisplayed(state);

  const shouldRenderHeader = getShouldRenderHeader(state);
  const shouldRenderNavigation = getShouldRenderNavigation(state);
  const shouldRenderFooter = getShouldRenderFooter(state);
  const shouldUseLegacyHeader = getIsUsingLegacyHeader(state);

  return {
    isMobile,
    isFullPage,
    isInPageSearchDisplayed,
    isInPageSearchEnabled,
    isNeedsRefreshDisplayed,
    shouldScrollToTop,
    shouldShowFooter,
    currentSubpage,
    sections: visibleSections,
    overlayAsset,
    overlayContent,
    useFixedNavLinks,
    shouldRenderHeader,
    shouldRenderNavigation,
    shouldRenderFooter,
    shouldUseLegacyHeader
  };
};


const mapDispatchToProps = (dispatch) => (
  {
    onScrolledToTop: () => {
      dispatch(doneScrollingToTop());
    },
    onSubpageDisplayedTrack: ()=> {
      dispatch(handleSubpageDisplayed());
    },
    onInPageSearchOpenerClick: ()=> {
      dispatch(setIsInPageSearchDisplayed(true));
    }
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubpageViewer);
